import { track } from 'stash/hooks/useTrack';
import {
	v1_DepositSetup_Failed,
	v1_DepositSetup_Submitted,
	v1_DepositSetup_Succeeded,
	v1_MoneyMovementSetup_Viewed,
} from '@stashinvest/product-events-javascript';
import { FlowType } from '@stashinvest/product-events-javascript/lib/enum_properties'; //ADD CASH SCREEN

export function trackDepositSetupSucceededEvent(amount, origin) {
	track(
		v1_DepositSetup_Succeeded({
			origin,
			flow_type: FlowType?.moneyMovement,
			destination: 'bank',
			destination_management_type: 'self_directed',
			frequency_type: 'one_time',
			frequency_schedule: null,
			amount,
			currency: 'USD',
		})
	);
}

const resourceUriToEventResource = {
	roboInvest: 'personal_brokerage',
	invest: 'personal_brokerage',
	retire: 'retirement',
	custodian: 'custodial',
	debit: 'bank',
	externalBank: 'external_bank',
};

const resourceUriToEventResourceType = {
	roboInvest: 'robo',
	invest: 'self_directed',
	retire: 'self_directed',
	custodian: 'self_directed',
	debit: 'self_directed',
};

const getEventResourceFromUri = (resource) => {
	const type = resource?.uri?.split('/')?.[0];
	return {
		resource: resourceUriToEventResource[type] || null,
		resourceType: resourceUriToEventResourceType[type] || null,
	};
};

export function trackMoneyMovementSetupViewedEvent(amount, source, destination, origin) {
	const sourceEvent = getEventResourceFromUri(source);
	const destinationEvent = getEventResourceFromUri(destination);

	track(
		v1_MoneyMovementSetup_Viewed({
			origin,
			source: sourceEvent.resource,
			source_management_type: sourceEvent.resourceType,
			destination: destinationEvent.resource,
			destination_management_type: destinationEvent.resourceType,
			amount,
			currency: 'USD',
			flow_type: FlowType?.moneyMovement,
			frequency_type: 'one_time',
		})
	);
}

export function trackDepositSetupSubmittedEvent(amount, origin) {
	track(
		v1_DepositSetup_Submitted({
			origin,
			flow_type: FlowType?.moneyMovement,
			destination: 'bank',
			destination_management_type: 'self_directed',
			frequency_type: 'one_time',
			frequency_schedule: null,
			amount,
			currency: 'USD',
		})
	);
}

export function trackDepositSetupFailedEvent(origin) {
	track(
		v1_DepositSetup_Failed({
			error_type: 'api_error',
			flow_type: FlowType?.moneyMovement,
			origin,
		})
	);
}
